var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 75,
    viewBox: "0 0 172 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0161 5.14648L15.7598 52.3488H70.2649L43.0161 5.14648Z",
    fill: "#5DB7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0162 20.9058L29.624 44.1025H56.4085L43.0162 20.9058Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6387 43.8406V52.4092H52.4986V43.8406H33.6387Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7917 39.481H33.6011V66.6774H38.7917V39.481Z",
    fill: "#0C4480"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7502 46.3799H40.5596V70.7675H45.7502V46.3799Z",
    fill: "#0C4480"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5212 39.4736H47.3306V66.67H52.5212V39.4736Z",
    fill: "#0C4480"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3751 44.7538H85.6719L83.5672 50.8282H76.8486L88.3159 18.8906H95.761L107.228 50.8282H100.465L98.3676 44.7538H98.3751ZM96.6374 39.6381L92.0235 26.2983L87.4096 39.6381H96.6374Z",
    fill: "#0C4480"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.304 18.936V50.8287H139.908V30.0887L131.362 50.8287H126.515L117.924 30.0887V50.8287H111.528V18.936H118.793L128.935 42.6496L139.076 18.936H146.297H146.304Z",
    fill: "#0C4480"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159 18.936V50.8287H152.603V18.936H159Z",
    fill: "#0C4480"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmi);
export default __webpack_public_path__ + "static/media/Ami.8dc13d7c4f491af5e8179705021764c2.svg";
export { ForwardRef as ReactComponent };